'use client';

import cn from 'classnames';
import { Button, ButtonVariant } from '@/shared/ui/core';
import { ButtonProps } from '@/shared/ui/core/button/model/button.types';
import { useRouter } from 'next/navigation';
import { ReactNode, useTransition } from 'react';
import { logoutRequest } from '@/shared/api/auth/logout';
import styles from './logout-button.module.scss';


type LogoutButtonProps = {
    children?: ReactNode;
    className?: string;
    onClick?: () => void;
    redirectTo?: string;
    variant?: ButtonVariant | undefined
} & ButtonProps;


export const LogoutButton = ({
    redirectTo,
    className,
    children = 'Log out',
    variant = 'naked',
    ...props
}: LogoutButtonProps) => {
    const router                         = useRouter();
    const [ isPending, startTransition ] = useTransition();

    const handleLogout = () => {
        startTransition(async () => {
            await logoutRequest();
            if (redirectTo) router.replace(redirectTo);
            else router.refresh();
        });
    };

    return (
        <Button
            variant={ variant }
            onMouseDown={ handleLogout }
            loading={ isPending }
            className={ cn(styles.root, className) }
            { ...props }
        >
            { isPending ? 'Logging out…' : children }
        </Button>
    );
};
